import { Navigate, useLocation } from 'react-router-dom';
import { accountNeedsSetup } from '../../lib/accountSetup';
import { useAuth } from '../../lib/auth';
import { accountContinuePath } from '../../lib/shareContinue';
import { safeNext } from '../../lib/phoneAppsPrompt';

/**
 * Shared step for every new account. create_account sets
 * phone_apps_prompt_pending, and this gate runs before the app,
 * including public pages a sign-in can land on.
 */
export function welcomeAppsHref(pathname, search, user) {
  if (!user?.phone_apps_prompt_pending) return null;
  if (pathname === '/welcome/apps') return null;
  const continued = accountContinuePath();
  const here = `${pathname || ''}${search || ''}`;
  let candidate = continued || here;
  if (accountNeedsSetup(user) && (candidate === '/' || candidate === '')) candidate = '/onboarding';
  const next = safeNext(candidate) || (accountNeedsSetup(user) ? '/onboarding' : '/');
  return `/welcome/apps?next=${encodeURIComponent(next)}`;
}

export default function PhoneAppsGate() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || !user) return null;
  const href = welcomeAppsHref(location.pathname, location.search, user);
  if (!href) return null;
  return <Navigate to={href} replace />;
}
